import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {EMPTY, Subject, catchError, takeUntil, tap, lastValueFrom} from 'rxjs';
import {Item as dxListItem} from 'devextreme/ui/list';

import {ValidFeature} from 'app/Model/ValidFeature';
import {ValidFeatureSystem} from 'app/Model/ValidFeatureSystem';
import {ItemClickEvent} from 'devextreme/ui/list';
import {NextPimField} from 'app/Model/Catalog/NextPimField';
import {ValidFeatureService} from 'app/Services/validFeature.service';
import {fieldNames} from 'app/Model/FieldNames';
import {ValueChangedEvent} from 'devextreme/ui/drop_down_box';
import {TemplateItem} from 'app/Model/Catalog/TemplateItem';
import {TemplateService} from 'app/Services/template.service';
import {comparePimFields, fillLastKey, isNextPimField, parsePimField} from 'app/Services/templateItemHelpers';
import {ValueChangedEvent as NumberBoxValueChangeEvent} from 'devextreme/ui/number_box';
import {TemplateItemTemplate} from '../../Model/Catalog/TemplateItemTemplate';
import {DxDropDownBoxComponent} from 'devextreme-angular';
import {TemplateFieldsService} from "../../Services/templateFields.service";
import {LoginService} from "../../Services/login.service";

@Component({
  selector: 'np-advanced-template-feature',
  templateUrl: './advanced-template-feature.component.html',
})
export class AdvancedTemplateFeatureComponent implements OnInit {
  @Input() templateItem: TemplateItem;
  @Input() validFeatureSystems: ValidFeatureSystem[] = [];
  @Output() onUpdate = new EventEmitter<void>();

  fieldList: TemplateItemTemplate[] = this.fieldService.featureFields;
  selectedValidFeatureSystem: ValidFeatureSystem = new ValidFeatureSystem();
  validFeatures: ValidFeature[] = [];
  selectedValidFeature: ValidFeature = new ValidFeature();

  get pimField() {
    if (!this.templateItem.pimFields || this.templateItem.pimFields.length === 0) {
      this.templateItem.pimFields = [new NextPimField()];
    }
    return this.templateItem.pimFields[0];
  }

  get isFeatureSystemOnly() {
    const templateItemTemplates = this.fieldList.filter((x) => x.field === this.pimField.field);
    if (templateItemTemplates?.length > 0) {
      return !templateItemTemplates[0].element;
    }
    return true;
  }

  constructor(private templateService: TemplateService, private validFeatureService: ValidFeatureService, private fieldService: TemplateFieldsService, private loginService: LoginService) {
  }

  ngOnInit() {
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  async onValidFeatureSystemChanged(event: ValueChangedEvent) {
    await this.loadValidFeatures(this.pimField.systemKey);
    this.update();
  }

  onOrderChanged(event: NumberBoxValueChangeEvent) {
    this.normalizeElementKey(event.value);
    this.update();
  }

  update(emit = true) {
    if (this.pimField.useSequence) {
      this.normalizeElementKey(parseInt(this.pimField.elementKey));
    }
    const {field, systemKey = '-1', elementKey = '-1'} = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key, systemKey, elementKey);
    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }

    this.templateService
      .getHeadline(field, elementKey, systemKey, this.loginService.currentCustomer.id)
      .subscribe((headline) => {
        fillLastKey(this.templateItem, headline.value);
        this.onUpdate.emit();
      });
  }

  private async loadValidFeatures(systemId: string) {
    console.log(systemId);
    let features = await lastValueFrom(this.validFeatureService.getFeatures(systemId, this.loginService.currentCustomer.id, false));
    if (!features) return;
    this.validFeatures = features;
  }

  private normalizeElementKey(value: number) {
    if (isNaN(value) || value <= 0) {
      this.pimField.elementKey = '1';
    } else {
      this.pimField.elementKey = value.toString();
    }
  }

  protected readonly parseInt = parseInt;
}
